import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/trap-icon-set.svg';

const SnapTrapStatus_2: React.FC = () => {
  return <img src={Icon} height={30} alt="Snap Status 2 Icon" />;
};

export default SnapTrapStatus_2;
